import { render, staticRenderFns } from "./identity.vue?vue&type=template&id=40225fa9"
import script from "./identity.vue?vue&type=script&lang=js"
export * from "./identity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports